module.exports = __webpack_public_path__ + "static/grid-431b48ab726c3561fafd1cd551c3f24c.svg";